import React from "react";
import { IconDisableLight, skinVars } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { strings } from "../../../../localization";
import Feedback from "../../../../components/templates/Feedback";
import { useGlobalStore } from "../../../../contexts/globalStoreContext";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";

const ValidateDocumentsRefused: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const { title, description } = strings.pages.validateDocumentsUnderRefused;
	const { toGoOut } = strings.components.buttons;
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const onAction = React.useCallback(() => {
		addAnalyticEvent({
			component: "button",
			action: "click.button",
			step: "fgts:cadastro:documentos-reprovados",
			event: "interaction",
			product: "fgts",
			description: toGoOut,
		}, {applySanitize: true});
		authenticationStore.logout();
		navigate("/");
	}, []);

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro FGTS Documentos Reprovados",
			pagePath: "/cadastro-fgts/documentos-reprovados",
		});
	}, []);

	return (
		<Feedback
			heroDataInfoProps={{
				icon: <IconDisableLight size={64} color={skinVars.colors.brand} />,
				title,
				description,
			}}
			buttonProps={{
				textButton: toGoOut,
				onAction,
			}}
		/>
	);
});

export default ValidateDocumentsRefused;
